






























import Vue from "vue";
import "@infoland/iprova-api"; //imports extension for date formatting
import Utils from "../../../utils";
import { NewsArticle, news_article_type } from "@infoland/iprova-api";
import NewsArticleListItem from "./NewsArticleListItem.vue";

export default Vue.extend({
    name: "NewsArticleList",
    components: { NewsArticleListItem },
    props: {
        onClickFunction: { type: Function, default: () => 1 },
        portalId: Number,
        newsArticles: Array as () => NewsArticle[]
    },
    data: () => ({}),
    methods: {
        toCalendar(itemDate: Date): string {
            return Utils.formatDateToCalendar(itemDate);
        },
        isSummaryAvailable(item) {
            if (item.summary) {
                return true;
            } else {
                return false;
            }
        },
        setListItemTitle(item) {
            if (item.type == news_article_type.content_item && item.content_item) {
                return item.content_item.title;
            } else {
                return item.title;
            }
        },
        openContentItem(item: NewsArticle) {
            Utils.openContentItem(item.content_item, this.$router, this.portalId);
        }
    }
});
